export const authConstant = {
	LOGIN_REQUSET: 'LOGIN_REQUSET',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILED: 'LOGIN_FAILED',
};

export const LogoutConstant = 'LOGOUT__SUCCESS';
